import ACTIONS from '../constants/actionsTypes';

export function getStatusVisuallyImpaired(params) {
return dispatch => dispatch({
        type : ACTIONS.GET_VISUALLY_IMPAIRED,
        data : params
    });
}
